import script from "./DepartmentToggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepartmentToggle.vue?vue&type=script&lang=ts&setup=true"

import "./DepartmentToggle.vue?vue&type=style&index=0&id=3b4a3423&lang=css"

const __exports__ = script;

export default __exports__